import { uniqueID } from '../../utilities/js/helper';
import noUiSlider from 'nouislider';
import wNumb from 'wnumb';

class RangeSlider {
    constructor (el, options) {
        const defaults = {
            type: 'single',
            from: 'data-rangeslider-from',
            to: 'data-rangeslider-to',
            onUpdate: null,
            destroyAndRenew: null
        };
        this.settings = Object.assign({}, defaults, options);
        this.$rangeSlider = el;
        this.rangeSliderId = '';
        this.sliderId = '';
        this.$slider = document.createElement('div');
        this.$from = '';
        this.$to = '';
        this.start = [];
        this.connect = [];
        this.startFrom = '';
        this.startTo = '';
        this.rangeFrom = '';
        this.rangeTo = '';

        this.initialize();
    }

    initialize () {
        this.$rangeSlider.setAttribute('id', `rangeslider-${uniqueID()}`);
        this.rangeSliderId = this.$rangeSlider.id;
        this.sliderId = `${this.rangeSliderId}__slider`;
        this.$slider.setAttribute('id', this.sliderId);
        this.$rangeSlider.insertAdjacentElement('afterend', this.$slider);

        const handleSlider = document.getElementById(this.sliderId);

        if (this.settings.type === 'multiple') {
            this.$from = this.$rangeSlider.querySelector('[' + this.settings.from + ']');
            this.$to = this.$rangeSlider.querySelector('[' + this.settings.to + ']');

            this.$from.setAttribute('readonly', true);
            this.$to.setAttribute('readonly', true);

            if (!this.$from && !this.$to) {
                return;
            }

            this.connect = [false, true, false];

            this.startFrom = this.$from.value;
            this.startTo = this.$to.value;
            this.start.push(this.startFrom);
            this.start.push(this.startTo);
            this.rangeFrom = parseInt(this.$from.getAttribute(this.settings.from));
            this.rangeTo = parseInt(this.$to.getAttribute(this.settings.to));
        }

        noUiSlider.create(handleSlider, {
            start: this.start,
            step: 100,
            format: wNumb({
                decimals: 0
            }),
            connect: this.connect,
            range: {
                min: [this.rangeFrom],
                max: [this.rangeTo]
            }
        });

        handleSlider.noUiSlider.on('update', (values) => {
            this.sliderUpdate(values, true);
        });

        this.sliderUpdate([this.startFrom, this.startTo], false);

        this.settings.destroyAndRenew = () => {
            handleSlider.noUiSlider.destroy();
            noUiSlider.create(handleSlider, {
                start: this.start,
                step: 100,
                format: wNumb({
                    decimals: 0
                }),
                connect: this.connect,
                range: {
                    min: [this.rangeFrom],
                    max: [this.rangeTo]
                }
            });

            handleSlider.noUiSlider.on('update', (values) => {
                this.sliderUpdate(values, true);
            });

            this.sliderUpdate([this.rangeFrom, this.rangeTo], false);
        };
    }

    sliderUpdate (values, makeFormat) {
        if (typeof this.settings.onUpdate === 'function') {
            this.settings.onUpdate(values, makeFormat);
        }
    }
}

export { RangeSlider };
